import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section className="w-full bg-gradient-to-b from-blue-100 to-white py-20 px-4" data-id="element-109">
      <div className="max-w-6xl mx-auto text-center" data-id="element-110">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-6" data-id="element-111">
          High-Quality SEO Content & Blog Writing That Delivers Results
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto mb-10" data-id="element-112">
          I create engaging, research-based, and SEO-optimized content tailored
          to your brand and audience.
        </p>
        <a href="#portfolio" className="inline-flex items-center px-8 py-4 bg-blue-600 text-white rounded-full font-medium text-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl" data-id="element-113">
          View My Portfolio
          <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-114" />
        </a>
      </div>
    </section>;
}